import React, { FC } from 'react';

import Image from 'next/image';
import { useTranslation } from 'next-i18next/pages';

import SecondImage from '@/assets/about-photo/about-photo-2.webp';
import FirstImage from '@/assets/about-photo/about-photo-3.webp';
import { TranslationNamespace } from '@/i18n';

import styles from './MainInfoSection.module.scss';

type Props = {
	descriptions: string[];
};

export const MainInfoSection: FC<Props> = ({ descriptions }) => {
	const { t } = useTranslation(TranslationNamespace.Marketing);
	return (
		<section className={styles.firstSection}>
			<div className={styles.content}>
				<div className={styles.descriptionBlock}>
					<h1 className={styles.title}>
						{t('about-us-container.platform-for-fishermen-from-fishermen')}
					</h1>
					<div className={styles.descriptions}>
						{descriptions.map((text) => (
							<div key={text}>{text}</div>
						))}
					</div>
				</div>
				<div className={styles.imagesBlock}>
					<div className={styles.mobileImages}>
						<div className={styles.mobileImage}>
							<Image
								className={styles.photo}
								src={SecondImage}
								alt={t('about-us-container.team-at-exhibition')}
							/>
						</div>
					</div>
					<div className={styles.desktopImages}>
						<div className={styles.firstImageItem}>
							<Image
								className={styles.photo}
								src={FirstImage}
								alt={t('about-us-container.platform-demonstration-at-exhibition')}
							/>
						</div>
						<div className={styles.secondImageItem}>
							<Image
								className={styles.photo}
								src={SecondImage}
								alt={t('about-us-container.team-at-exhibition')}
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};
